import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CartListContainer } from './Cart'
import { CheckoutShippingAddress } from './Address'
import { CheckoutSummaryContainer } from './Summary'
import { CheckoutCompleteContainer } from './PlaceOrder'
import { MessagesList } from './UserMessaging'
import { CheckoutShipment } from './ShippingMethod'
import { CheckoutPayment } from './PaymentMethod'
import { CheckoutBillingAddress } from './Address'
import CheckoutPromoGiftCard from './CheckoutPromoGiftCard'
import { CheckoutNotes } from './Notes'

class Components extends Component {

    componentDidMount() {

        // BBS DDD This should be refactored and moved into component animations, or
        // a renderProp component
        // https://reactjs.org/docs/render-props.html

        let docWidth = 0, docTop = 0;
        if (typeof document !== 'undefined' && document.documentElement) {

            docWidth = document.documentElement.clientWidth;
            docTop = document.documentElement.getBoundingClientRect().top
        } else {
            if (typeof window.innerWidth !== 'undefined' && window.innerWidth)
                docWidth = window.innerWidth;
        }
        const minPortWidthPx = 767;
        if (docWidth > minPortWidthPx) {
        }
    }

    render() {
        if (this.props.checkoutIsEmpty) {
            return (
                <div className="checkout">
                    <div className="col-xs-12 text-center">
                        <p>Your cart is empty.</p>
                        <p><a href="/">Back to home.</a></p>
                    </div>
                </div>
            )
        }
        return (
            <div className="checkout row">
                <div className="col-xs-12 d-block d-md-none">
                    <CheckoutCompleteContainer />
                    <CheckoutSummaryContainer />
                    <MessagesList />
                </div>

                <div className="col-md-8" style={{ marginBottom: 20 }}>
                    <CheckoutShippingAddress />
                    <CheckoutShipment />
                    <CheckoutPayment />
                    <CheckoutBillingAddress />
                    <CheckoutNotes />
                    <CheckoutPromoGiftCard />
                    <CartListContainer />
                </div>

                <div className="col-md-4 d-none d-md-block" id='right-summary-container'>
                    <div id='right-summary'>
                        <CheckoutSummaryContainer />
                        <CheckoutCompleteContainer />
                        <MessagesList />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    checkoutIsEmpty: state.entities.CartItems.length < 1
});

export default connect(mapStateToProps)(Components)